const INITIAL_STATE = {
    activeTournaments: [],
    activeTrials: [],
    user: {},
    dashboardLoading: true
  };
  
  export default INITIAL_STATE;
  